export const blogConfig = {
  integrations: {
    facebookAppId: process.env.GATSBY_FACEBOOK_APP_ID,
  },
}
